import { render, staticRenderFns } from "./distributionDetailDialog.vue?vue&type=template&id=0ef570ed&scoped=true"
import script from "./distributionDetailDialog.vue?vue&type=script&lang=js"
export * from "./distributionDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./distributionDetailDialog.vue?vue&type=style&index=0&id=0ef570ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef570ed",
  null
  
)

export default component.exports